import React from 'react'
import styles from './Title.module.css'

function Title({ children }) {
  return (
    <div className={styles.page_title}> 
        <h1 className={styles.title}>{children}</h1>
    </div>
  )
}

export default Title